import * as React from 'react';
export var IframeComponent = function (props) {
    var wrapperStyle = {
        textAlign: props.value.align || 'center'
    };
    var iframeStyle = {
        height: props.value.height || 400
    };
    return (React.createElement("div", { className: 'component iframe-component', "data-component-type": 'iframe' },
        React.createElement("div", { className: 'iframe-wrapper', style: wrapperStyle },
            React.createElement("iframe", { src: props.value.url, style: iframeStyle, scrolling: props.value.scrolling || 'auto' }))));
};
//# sourceMappingURL=iframe-component.comp.js.map